module.exports = __webpack_public_path__ + "static/media/beforelike.1537016b.svg";